<div class="h-full">
  <div class="p-6 flex flex-col">
    <div class="mb-8">
      <div class="flex justify-between items-center mb-8">
        <span class="text-2xl font-bold text-primary">{{ cardTitle() }}</span>
      </div>
      <hr class="border-gray-300" />
    </div>

    <div class="w-full overflow-x-auto">
      <p-table
        [value]="tableData()"
        [paginator]="true"
        [rows]="pageSize()"
        [totalRecords]="
          serverPaging() ? totalRecords() : tableData()?.length || 0
        "
        [lazy]="serverPaging()"
        (onLazyLoad)="serverPaging() && lazyLoad.emit($event)"
        [loading]="loading()"
        [responsiveLayout]="'scroll'"
        [scrollable]="true"
        [rowHover]="true"
      >
        <ng-template pTemplate="header">
          <tr>
            @for (header of headers(); track $index) {
            <th class="text-left text-dark text-base font-semibold px-4 py-2">
              {{ header }}
            </th>
            }
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
          <tr class="cursor-pointer" (click)="rowClick(row)">
            @for (key of keys(); track key; let i = $index) {
            <!-- title -->
            @if (types()[i] === 'TITLE') {
            <td class="px-4 py-2 text-base font-semibold text-gray-900">
              {{ row[key] | titlecase }}
            </td>
            } @else if (types()[i] === 'TEXT') {
            <td class="px-4 py-2 text-base text-gray-800">
              {{ row[key] }}
            </td>
            } @else if (types()[i] === 'WRAP') {
            <td class="px-4 py-2 text-base break-words text-gray-800 w-[300px]">
              {{ row[key] }}
            </td>
            } @else if (types()[i] === 'NUMBER') {
            <td class="px-4 py-2 text-base text-left text-gray-800">
              {{ row[key] }}
            </td>
            } @else if (types()[i] === 'CURRENCY') {
            <td class="px-4 py-2 text-base text-left">
              {{ row[key] > 0 ? (row[key] | currency : "EUR") : row[key] }}
            </td>
            } @else if (types()[i] === 'ARRAY') {
            <!-- iterate throught array items -->
            @for (item of row[key]; track $index) {
            <td class="px-4 py-2 text-base">{{ item }}<br /></td>
            }
            <!--stop  -->
            } @else if (types()[i] === 'PERCENTAGE') {
            <td class="px-4 py-2 text-base text-left">{{ row[key] }}%</td>
            } @else if (types()[i] === 'DATE') {
            <td class="px-4 py-2 text-base text-gray-700">
              {{ row[key] | date : "dd/MM/yyyy" }}
            </td>
            } @else if (types()[i] === 'BAR') {
            <td class="px-4 py-2 text-base">
              <div class="mb-1">
                {{ row[key] === 0 ? "-" : row[key] + "%" }}
              </div>
              @if (row[key] > 0) {
              <div class="w-full bg-gray-400 rounded">
                <div
                  class="bg-primary text-white text-sm leading-none py-[7px] rounded"
                  [style.width.%]="row[key]"
                ></div>
              </div>
              }
            </td>
            } }
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="10">
              {{ noDataMessage | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
